<template>
	<div>
		<transition name="fade">
			<div v-if="showLangSelect" class="lang-select-modal">
				<div class="lang-select-box">
					<h3>{{$t('selectLang') || '选择语言 / Select Language'}}</h3>
					<button class="lang-btn" @click="selectLang('ch')">中文</button>
					<button class="lang-btn" @click="selectLang('en')">English</button>
				</div>
			</div>
		</transition>
		<transition name="fade">
			<div class="fadein_login" v-if="show && !showLangSelect">
				<div class="wx_code" v-show="wechat">
					<div class="boxs">
						<div class="child">
							<div id="qrcode"></div>
						</div>
						<img src="../assets/images/closes_03.png" @click="wechat = false" class="closes" />
					</div>
				</div>
				<div class="box">
					<img v-if="cLang=='en'" src="@/assets/images/logo_en.png" class="logo" style="max-width: 150px;"/>
					<img v-else src="@/assets/images/login_07.png" class="logo" />
					<img src="@/assets/images/login_03.png" @click="close" class="close" />
					<div class="form" v-if="flag">
						<div>
							<input type="text" v-model="email" class="mobile" :placeholder="$t('qsremail')" name="" id="" value="" />
						</div>
						<div>
							<input type="password" v-model="passWord"  class="password" :placeholder="$t('qsrmm')" name="" id="" value="" />
						</div>
						<input type="submit" @click="submit" class="submit" :value="$t('login')" />
					</div>
					<div class="type" v-if="!flag">
						<div @click="wechatflag">
							<img src="@/assets/images/login_11.png" />
							<span>{{$t('wechatlogin')}}</span>
						</div>
					</div>
					<label>
						<input type="checkbox" name="" id="checkbox" value="" />
						<p>{{$t('tybyd')}}<router-link to="/yinsi">{{$t('sytks')}}</router-link></p>
					</label>
					<div class="button">
						<p class="l" @click="flag = !flag"><img src="@/assets/images/left4_03.png" style="transform: translateY(1px);" v-if="flag" />{{flag?$t('wechat'):$t('email')}}</p>
						<p>{{$t('myzh')}}？
							<router-link to="/register">{{$t('ljzc')}}</router-link>
						</p>
						<p>
							<a href="javascript:;" @click="openResetPwd">{{$t('resetpw')}}</a>
						</p>
					</div>
				</div>
				<transition name="fade">
					<div class="reset-modal" v-if="showResetPwd">
						<div class="reset-box">
							<img src="@/assets/images/closes_03.png" class="close-btn" @click="showResetPwd = false" />
							<h3>{{$t('resetpw')}}</h3>
							<input
								type="text"
								v-model="resetEmail"
								placeholder="请输入邮箱"
								class="reset-input"
							/>
							<button class="reset-btn" @click="handleResetPwd">确认</button>
						</div>
					</div>
				</transition>
			</div>
		</transition>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'login',
		data() {
			return {
				flag: true,
				email: '',
				passWord: '',
				wechat: false,
				showResetPwd: false,
				resetEmail: '',
				cLang:'en',
				showLangSelect: false,
			}
		},
		mounted() {
			// 只有在未设置过语言的情况下才显示语言选择框
			if (!localStorage.getItem('lang')) {
				this.showLangSelect = true;
			} else {
				this.showLangSelect = false;
				this.cLang = localStorage.getItem('lang');
			}
			let userinfo=this.$route.query.userinfo;
			console.log(userinfo);
			if(userinfo!=undefined){
				this.loading = this.$loading();
				protal.getWXLogin({
					userinfo: userinfo
				}).then(res => {
					if(res.code == 200) {
						console.log(res);
						localStorage.setItem("token", res.result.token);
						localStorage.setItem("userinfo", JSON.stringify(res.result.user));
						this.$message({
							message: this.$t('loginsuccess'),
							type: 'success',
							duration: 700
						});
						this.$emit('loginChange', 1)
						this.$store.commit("changeLoginFlag", true);
						this.$store.commit("getUserinfo");
						
						// 获取用户信息并更新VIP状态
						protal.getUserInfo().then(res => {
							if(res.code == 200) {
								localStorage.setItem("userinfo", JSON.stringify(res.result));
								this.$store.commit("getUserinfo");
							}
						});
						
						setTimeout(() => {
							this.close()
						}, 700)
					}else{
						this.$message({
							message: res.message,
							type: 'warning',
							duration: 700
						});
					}
					this.loading.close();
				})
			}
		},
		computed: {
			show() {
				return this.$store.state.loginShow;
			}
		},
		watch: {
			show(val) {
				if (val) {
					// 只有在未设置过语言时才显示语言选择
					this.showLangSelect = !localStorage.getItem('lang');
				}
			}
		},
		methods: {
			selectLang(lang) {
				this.cLang = lang;
				localStorage.setItem("lang", lang);
				this.$i18n && (this.$i18n.locale = lang);
				this.$store.commit("changeLanguage", lang);
				this.showLangSelect = false;
			},
			wechatflag() {
				this.wechat = true
				this.initSDK();
			},
			initSDK() {
				var obj = new WxLogin({
					self_redirect: false,
					id: 'qrcode',
					appid: 'wxff733dd31708f959',
					scope: 'snsapi_login',
					redirect_uri: encodeURIComponent('https://ptestudy.com/wechat/login.php'),
					state: 'n3d6be0a4035d839573b04816624a415ncpte',
					style: 'white',
					href: '',
				})
			},
			submit() {
				if(!this.email) {
					return this.$message({
						message: this.$i18n.t('qsremail'),
						type: 'warning'
					});

				}
				if(!this.passWord) {
					return this.$message({
						message: this.$i18n.t('qsrmm'),
						type: 'warning'
					});
				}
				if(!$('#checkbox').prop("checked")) {
					return this.$message({
						message: this.$i18n.t('confirmrules'),
						type: 'warning'
					});
				}
				this.loading = this.$loading();
				protal.getLogin({
					email: this.email,
					passWord: this.passWord
				}).then(res => {
					if(res.code == 200) {
						localStorage.setItem("token", res.result.token);
						localStorage.setItem("userinfo", JSON.stringify(res.result.user));
						this.$message({
							message:  this.$t('loginsuccess'),
							type: 'success',
							duration: 700
						});
						this.$emit('loginChange', 1)
						this.$store.commit("changeLoginFlag", true);
						this.$store.commit("getUserinfo");
						
						// 获取用户信息并更新VIP状态
						protal.getUserInfo().then(res => {
							if(res.code == 200) {
								localStorage.setItem("userinfo", JSON.stringify(res.result));
								this.$store.commit("getUserinfo");
							}
						});
						
						setTimeout(() => {
							this.close()
						}, 700)
					}else{
						this.$message({
							message: res.message,
							type: 'warning',
							duration: 700
						});
					}
					this.loading.close();
				})
			},
			close() {
				this.$store.commit("changeLogin", false);
			},
			openResetPwd() {
				this.showResetPwd = true;
				this.resetEmail = '';
			},
			handleResetPwd() {
				if (!this.resetEmail) {
					return this.$message({
						message: this.$i18n.t('pinputemail'),
						type: 'warning'
					});
				}
				const emailReg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
				if (!emailReg.test(this.resetEmail)) {
					return this.$message({
						message: this.$i18n.t('invalidEmail'),
						type: 'warning'
					});
				}
				this.loading = this.$loading();
				protal.resetPassword({ email: this.resetEmail }).then(res => {
					this.loading.close();
					if (res.code == 200) {
						this.$message({
							message: '重置密码邮件已发送，请查收',
							type: 'success'
						});
						this.showResetPwd = false;
					} else {
						this.$message({
							message: res.message,
							type: 'warning'
						});
					}
				}).catch(() => {
					this.loading.close();
					this.$message({
						message: '请求失败，请稍后重试',
						type: 'error'
					});
				});
			},
		},
	}
</script>

<style lang="less" scoped>
	.wx_code {
		width: 100%;
		height: 100%;
		background: #999999;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		.boxs {
			.child {
				width: 500px;
				overflow: hidden;
				padding: 50px 0;
				background: #333;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.closes {
				cursor: pointer;
				display: block;
				margin: 0 auto;
				margin-top: 20px;
			}
			/*p {
				text-align: center;
				font-size: 16px;
				color: #fff;
			}
			div {
				width: 350px;
				height: 350px;
				margin: 30px auto;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span {
				text-align: center;
				font-size: 14px;
				display: block;
				color: #fff;
			}*/
		}
	}
	
	@media screen and (min-width: 769px) {
		.footer {
			background: #eee;
			padding: 0 1.1rem;
			.content {
				display: flex;
			}
			.left {
				padding: .97rem 0 0;
				display: flex;
				li {
					width: 1.8rem;
					margin-right: .2rem;
					&:last-child {
						margin-right: 0;
					}
					img {
						display: block;
						width: 1.8rem;
						height: 1.8rem;
					}
					p {
						margin-top: .2rem;
						font-size: .2rem;
						color: #727171;
						line-height: 1;
						text-align: center;
					}
				}
			}
			.list {
				flex: 1;
				margin-left: 1rem;
				padding-top: .53rem;
				h2 {
					font-size: .24rem;
					font-weight: 600;
					color: #000000;
					line-height: 1;
					padding-bottom: .2rem;
					border-bottom: 1px solid #B4B4B5;
				}
				.link {
					display: flex;
					flex-wrap: wrap;
					span {
						flex: 0 0 50%;
						font-size: .18rem;
						line-height: .27rem;
						font-weight: 400;
						color: #727171;
						margin-top: .15rem;
					}
				}
			}
			.beian {
				padding: .4rem 1.1rem .32rem 1.1rem;
				font-size: .18rem;
				font-weight: 400;
				color: #727171;
				text-align: center;
				line-height: .4rem;
				display: flex;
				align-items: center;
				span {
					line-height: .4rem;
					display: inline-flex;
					align-items: center;
					margin-left: .2rem;
					img {
						width: .2rem;
						height: auto;
						margin-right: .06rem;
					}
				}
			}
		}
	}
	/* 媒体查询（手机） */
	
	@media screen and (max-width: 768px) {
		.footer {
			background: #eee;
			padding: .4rem 0 .4rem;
			.left {
				padding: 0 .6rem;
				display: flex;
				justify-content: space-between;
				li {
					width: 3rem;
					img {
						display: block;
						width: 3rem;
						height: 3rem;
					}
					p {
						margin-top: .2rem;
						font-size: .24rem;
						color: #727171;
						line-height: 1;
						text-align: center;
					}
				}
			}
			.list {
				width: 6.7rem;
				margin: .8rem auto 0;
				&.list2 {
					margin-top: .6rem;
				}
				h2 {
					font-size: .32rem;
					font-weight: 600;
					color: #000000;
					line-height: 1;
					padding-bottom: .14rem;
					border-bottom: 1px solid #B4B4B5;
				}
				.link {
					display: flex;
					flex-wrap: wrap;
					span {
						flex: 0 0 50%;
						font-size: .24rem;
						font-weight: 400;
						color: #727171;
						margin-top: .16rem;
					}
				}
			}
			.beian {
				margin-top: .7rem;
				font-size: .24rem;
				font-weight: 400;
				color: #727171;
				line-height: 1;
				text-align: center;
				span {
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: .24rem;
					line-height: 1.9;
					img {
						width: .24rem;
						height: auto;
						margin-right: .06rem;
					}
				}
			}
		}
	}
	.reset-modal {
		position: fixed; left: 0; top: 0; right: 0; bottom: 0;
		background: rgba(0,0,0,0.4); z-index: 2000;
		display: flex; align-items: center; justify-content: center;
	}
	.reset-box {
		background: #fff; padding: 30px 20px; border-radius: 8px; min-width: 300px; position: relative;
		display: flex; flex-direction: column; align-items: center;
	}
	.close-btn {
		position: absolute; right: 10px; top: 10px; width: 20px; height: 20px; cursor: pointer;
	}
	.reset-input {
		width: 220px; margin: 20px 0; padding: 8px; border: 1px solid #ccc; border-radius: 4px;
	}
	.reset-btn {
		width: 120px;
		padding: 8px 0;
		background: #409EFF;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
	}
	.lang-select-modal {
		position: fixed; left: 0; top: 0; right: 0; bottom: 0;
		background: rgba(0,0,0,0.4); z-index: 3000;
		display: flex; align-items: center; justify-content: center;
	}
	.lang-select-box {
		background: #fff; padding: 30px 20px; border-radius: 8px; min-width: 300px; position: relative;
		display: flex; flex-direction: column; align-items: center;
	}
	.lang-btn {
		width: 120px; margin: 10px 0; padding: 8px 0; background: #409EFF; color: #fff; border: none; border-radius: 4px; cursor: pointer;
		font-size: 18px;
	}
</style>


// WEBPACK FOOTER //
// src/components/login.vue